import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  apiRoleToAccountType,
  getAccountTypeRoute,
  getAuthUser,
  hasDashboardAccess,
  isAuthenticated,
} from "../auth";
import { useAuth } from "../providers/AuthProvider";

export function RequireDashboardAccess() {
  const location = useLocation();
  const { ready } = useAuth();

  if (isAuthenticated() && !ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted">
        Vérification de la session…
      </div>
    );
  }

  if (!hasDashboardAccess()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export function RedirectIfAuthenticated() {
  const user = getAuthUser();

  if (isAuthenticated() && user) {
    return <Navigate to={getAccountTypeRoute(apiRoleToAccountType(user.role))} replace />;
  }

  return <Outlet />;
}
